/* eslint-disable max-len */
import { useQuery } from '@apollo/client';
import React, { useMemo, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import DashboardWrap from '../../../components/DashboardWrap';
import EmptyPageLoader from '../../../components/EmptyPageLoader';
import StyledButton from '../../../components/StyledButton';
import UserDetailsCardCa from '../../../components/UserDetailsCardCa';
import { GET_SINGLE_STAFF } from '../../../graphql/admin_queries';
import GoBackIcon from '../../../svgs/GoBackIcon';
import { cleanSingleMemberRecord } from '../../../utils/helpers';
import InviteNewStaff from '../UserManagement/_partials/InviteMember';
import Styles from './UserManagementDetails.module.scss';
import MemberInformation from './_partials/MemberInformation';

const UserManagementDetails = () => {
  const history = useHistory();
  const { memberId } = useParams<{ memberId: string }>();

  const [showEditModal, setShowEditModal] = useState(false);
  const { data, refetch, loading } = useQuery<
  {
    getSingleStaff: any;
  },
  { adminId: string }
>(GET_SINGLE_STAFF, { variables: { adminId: memberId } });

  const singleStaff = useMemo(() => data?.getSingleStaff?.data, [data]);
  const payload = cleanSingleMemberRecord(singleStaff);

  return (
    <DashboardWrap className={Styles.wrapper}>
      {
        loading ? <EmptyPageLoader /> : (
          <div className={Styles.wrapper__container}>
            <div className={Styles.wrapper__titleContainer}>
              <GoBackIcon onClick={() => history?.goBack()} />
              User management
            </div>
            <UserDetailsCardCa payload={payload} hideLocation dropdownType="adminCustomer" showStatusBesideName>
              <StyledButton
                name="EDIT PROFILE"
                onClick={() => setShowEditModal(true)}
                backgroundColor="rgba(239, 241, 243, 1)"
                color="rgba(102, 112, 133, 1)"
                border={`${'1px solid rgba(102, 112, 133, 1)'}`}
                width="97px"
                height="40px"
                fontWeight={900}
                fontSize="13px"
                borderRadius="4px"
                padding="8px 12px"
              />
            </UserDetailsCardCa>
            <MemberInformation payload={payload} />
          </div>
        )
      }
      {
        showEditModal && (
        <div>
          <InviteNewStaff editDetails={payload} closeModal={() => setShowEditModal(false)} refetchData={refetch} />
        </div>
        )
      }

    </DashboardWrap>
  );
};

export default UserManagementDetails;
